<script setup>
  import { notify } from 'notiwind'
  import { handleError } from '@/utils/error'
  import sleep from '@/utils/sleep'

  const route = useRoute()

  onMounted(async () => {
    if (route.hash === '#newsletterOK') {
      await sleep(100)
      notify({
        group: 'main',
        type: 'success',
        title: 'Inscription confirmée',
        text: 'Vous recevrez désormais la newsletter Profil Public chaque semaine.'
      })
    } else if (route.hash === '#newsletterKO') {
      await sleep(100)
      handleError({ error: 'newsletter' }, 'Votre lien de confirmation est invalide.')
    }
  })
</script>

<template>
  <NewsletterForm footer input-class="max-h-[34px]" />
</template>
